import React from 'react';

export interface DescriptionElementProps{
    description?: string;
}

const Description: React.FC<DescriptionElementProps> = ({
    description = `Massa tempor nec feugiat nisl pretium. Egestas fringilla phasellus faucibus scelerisque 
    eleifend donec Porta nibh venenatis cras sed felis eget velit aliquet. 
    Neque volutpat ac tincidunt vitae semper quis lectus. 
    Turpis in eu mi bibendum neque egestas congue quisque. 
    Sed elementum tempus egestas sed sed risus pretium quam. 
    Dignissim sodales ut eu sem. 
    Nibh mauris cursus mattis molestee iaculis at erat pellentesque. 
    Id interdum velit laoreet id donec ultrices tincidunt.

    To the left is the modern kitchen with central island, 
    leading through to the unique breakfast family room which feature glass walls and 
    doors out onto the garden and access to the separate utility room.`
})=>{

    return(
        <p>
            {description}
        </p>
    )
}

export default Description;